import React from 'react';
import { Helmet } from 'react-helmet';
import { Holiday } from '../../models/holiday';

const { isArray } = Array;

interface MetadataProps {
  link: string;
  holidays: Holiday[];
  homepage: boolean;
}

const Metadata = ({ link, holidays = [], homepage }: MetadataProps) => (
  <Helmet>
    <script type={'application/ld+json'}>
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        url: link,
        numberOfItems: holidays.length,
        itemListElement: holidays.map(
          ({ title, summary, price_cents, slug, feature_images = [] }, i) => ({
            '@context': 'http://schema.org',
            '@type': 'Product',
            image:
              isArray(feature_images) && feature_images.length > 0
                ? feature_images[0].path
                : undefined,
            name: title,
            url: `https://travelat60.com/holidays/${slug}`,
            description: (summary || '').trim(),
            position: i + 1,
            offers: {
              '@type': 'Offer',
              price: (price_cents / 100).toFixed(2),
              priceCurrency: 'AUD',
            },
          })
        ),
      })}
    </script>
    {homepage && (
      <script type={'application/ld+json'}>
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Travel at 60',
          legalName: 'Travel at 60 Pty Ltd',
          url: 'https://travelat60.com',
          logo:
            'https://travelat60.com/images/favicons/android-chrome-192x192.png',
          foundingDate: 2016,
          founders: [
            {
              '@type': 'Person',
              name: 'Rebecca Wilson',
            },
          ],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            telephone: '[+61-1300414198]',
          },
        })}
      </script>
    )}
  </Helmet>
);

export default Metadata;
